import get from 'lodash/get';
import { feedBack } from '../actionTypes';

const successFetchingFeedBackDetailsData = payload => ({
  type: feedBack.SUCCESS_FETCHING_FEEDBACK_DETAILS_DATA,
  payload
});

const errorFetchingFeedBackDetailsData = payload => ({
  type: feedBack.FAILURE_FETCHING_FEEDBACK_DETAILS_DATA,
  payload
});

export const fetchfeedbackdetailsdata = feedback_id => dispatch => {
  dispatch({
    hmsFetchConfig: {
      path: '/hms_ms/api/v1/generic/campaign_page_widgets_v2',
      method: 'POST',
      queryParams: {
        page_type: 'medallia_feedback_details',
        campaign: 'data',
        clear_cache: true
      },
      body: {
        feedback_id: feedback_id
      }
    },

    onSuccess: ({ data }) => {
      const feedback_details_data = get(data, 'data.widget_list[0]', []);
      dispatch(successFetchingFeedBackDetailsData({ feedback_details_data }));
    },

    onError: ({ error }) => {
      dispatch(errorFetchingFeedBackDetailsData({ error }));
    }
  });
};
